var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarUnfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8203 3.08179L13.6592 8.74194H21.1504L19.9053 9.64624L15.0898 13.1453L16.9287 18.8054L17.4043 20.2693L16.1602 19.365L11.3447 15.866L6.5293 19.365L5.28418 20.2693L5.75977 18.8054L7.59766 13.1453L2.78418 9.64624L1.53906 8.74194H9.0293L10.8691 3.08179L11.3447 1.61792L11.8203 3.08179Z",
    stroke: "#FD9F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnfill);
export default __webpack_public_path__ + "static/media/star-unfill.18c2077c7d12cb918bbc14f4dada97f7.svg";
export { ForwardRef as ReactComponent };